import React, { useEffect, useState } from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { FaClipboardCheck, FaSpinner, FaCheckCircle, FaTimesCircle, FaPlus } from 'react-icons/fa';

const PHASE_STATUSES = ['Planning', 'Completed', 'Pending'];

export default function ClubEvaluation() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newProject, setNewProject] = useState({ project_name: '', category: '', chairperson: '', phases: [] });
  const [phaseInputs, setPhaseInputs] = useState({ name: '', status: 'Planning', date: '' });
  const [addingPhaseTo, setAddingPhaseTo] = useState(null);

  useEffect(() => {
    fetch('https://sliitleo.org/leo-club-backend/portal4/get_evaluation_projects.php')
      .then(res => res.json())
      .then(data => {
        setProjects(data);
        setLoading(false);
      })
      .catch(err => {
        setError('Failed to load projects');
        setLoading(false);
      });
  }, []);

  // Add new project
  const handleAddProject = () => {
    const toSend = { ...newProject, phases: [] };
    fetch('https://sliitleo.org/leo-club-backend/portal4/add_project.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(toSend)
    })
      .then(res => res.json())
      .then(added => {
        setProjects([added, ...projects]);
        setShowAddModal(false);
        setNewProject({ project_name: '', category: '', chairperson: '', phases: [] });
      });
  };

  // Add phase to a project
  const handleAddPhase = (projectId) => {
    if (!phaseInputs.name) return;
    const updatedProjects = projects.map(proj => {
      if (proj.project_id === projectId) {
        const newPhase = {
          name: phaseInputs.name,
          status: phaseInputs.status,
          date: phaseInputs.date
        };
        const updatedPhases = [...(proj.phases || []), newPhase];
        // Update backend
        fetch('https://sliitleo.org/leo-club-backend/portal4/update_phase_status.php', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ project_id: projectId, phases: updatedPhases })
        });
        return { ...proj, phases: updatedPhases };
      }
      return proj;
    });
    setProjects(updatedProjects);
    setPhaseInputs({ name: '', status: 'Planning', date: '' });
    setAddingPhaseTo(null);
  };

  const formatDate = (date) => {
    if (!date) return '-';
    const d = new Date(date);
    return d.toLocaleDateString();
  };
  // Get user info from localStorage
  const user = JSON.parse(localStorage.getItem('user')) || {
    name: 'Unknown User',
    role: 'Member',
    image: '/user.png',
  };
  return (
    <div className="flex bg-[#111827] text-white min-h-screen">
      <Sidebar />
      <Topbar user={user} />
      <main className="ml-64 mt-14 w-full px-8 py-10 relative">
        {/* Floating Add Project Button */}
        <button onClick={() => setShowAddModal(true)} className="fixed bottom-10 right-10 z-50 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full p-4 shadow-lg flex items-center gap-2">
          <FaPlus className="text-lg" /> Add Project
        </button>
        <div className="backdrop-blur-md bg-gradient-to-r from-[#23272f]/80 to-[#181b20]/80 border border-gray-800 rounded-2xl p-5 mb-8 flex items-center gap-4 shadow-lg">
          <span className="flex items-center gap-3">
            <span className="bg-indigo-600 p-2 rounded-full shadow-lg flex items-center justify-center">
              <FaClipboardCheck className="text-white text-2xl" />
            </span>
            <span className="text-lg font-bold tracking-wide text-white drop-shadow">Club Evaluation <span className="text-gray-400 font-normal">/ Projects</span></span>
          </span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {loading ? (
            <div className="col-span-full flex flex-col items-center justify-center py-12 text-indigo-300">
              <FaSpinner className="animate-spin text-3xl mb-2" />
              <span>Loading projects...</span>
            </div>
          ) : error ? (
            <div className="col-span-full flex flex-col items-center justify-center py-12 text-red-400">
              <FaTimesCircle className="text-3xl mb-2" />
              <span>{error}</span>
            </div>
          ) : projects.length === 0 ? (
            <div className="col-span-full flex flex-col items-center justify-center py-12 text-gray-400">
              <FaClipboardCheck className="text-3xl mb-2" />
              <span>No projects found</span>
            </div>
          ) : (
            projects.map((proj) => (
              <div key={proj.project_id} className="bg-[#23272f] rounded-xl border border-gray-800 shadow-lg p-6 flex flex-col gap-4">
                <div className="flex items-center gap-3 mb-2">
                  <span className="bg-indigo-500/20 p-2 rounded-full">
                    <FaClipboardCheck className="text-indigo-400 text-xl" />
                  </span>
                  <span className="font-bold text-lg text-white">{proj.project_name}</span>
                  <span className="ml-auto px-3 py-1 rounded-full text-xs font-semibold " style={{background: proj.report_status === 'Completed' ? 'rgba(34,197,94,0.2)' : 'rgba(251,191,36,0.2)', color: proj.report_status === 'Completed' ? '#22c55e' : '#fbbf24'}}>
                    {proj.report_status || 'Pending'}
                  </span>
                </div>
                <div className="text-sm text-gray-300 mb-2">
                  <div><span className="font-semibold">Category:</span> {proj.category || '-'}</div>
                  <div><span className="font-semibold">Officers:</span> {proj.chairperson || '-'}</div>
                  <div><span className="font-semibold">Date:</span> {formatDate(proj.date)}</div>
                </div>
                <div className="mb-2">
                  <div className="font-semibold text-indigo-300 mb-1">Phases:</div>
                  {(proj.phases && proj.phases.length > 0) ? (
                    <ul className="space-y-2">
                      {proj.phases.map((phase, idx) => (
                        <li key={idx} className="flex items-center gap-2 text-xs bg-[#181b20] px-3 py-2 rounded-lg border border-gray-700">
                          <span className={`w-2 h-2 rounded-full ${phase.status === 'Completed' ? 'bg-green-400' : phase.status === 'Planning' ? 'bg-yellow-400' : 'bg-red-400'}`}></span>
                          <span className="font-semibold">{phase.name}</span>
                          <span className="ml-auto px-2 py-0.5 rounded-full text-xs font-medium" style={{background: phase.status === 'Completed' ? 'rgba(34,197,94,0.2)' : phase.status === 'Planning' ? 'rgba(251,191,36,0.2)' : 'rgba(239,68,68,0.2)', color: phase.status === 'Completed' ? '#22c55e' : phase.status === 'Planning' ? '#fbbf24' : '#ef4444'}}>
                            {phase.status}
                          </span>
                          <span className="ml-2 text-gray-400">{formatDate(phase.date)}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="text-xs text-gray-400">No phases yet.</div>
                  )}
                  {/* Add Phase Button */}
                  {addingPhaseTo === proj.project_id ? (
                    <div className="mt-2 flex flex-col gap-2 bg-[#181b20] p-3 rounded-lg border border-gray-700">
                      <input className="bg-[#23272f] border border-gray-700 rounded px-2 py-1 text-xs text-white" placeholder="Phase Name" value={phaseInputs.name} onChange={e => setPhaseInputs({...phaseInputs, name: e.target.value})} />
                      <select className="bg-[#23272f] border border-gray-700 rounded px-2 py-1 text-xs text-white" value={phaseInputs.status} onChange={e => setPhaseInputs({...phaseInputs, status: e.target.value})}>
                        {PHASE_STATUSES.map(status => <option key={status} value={status}>{status}</option>)}
                      </select>
                      <input type="date" className="bg-[#23272f] border border-gray-700 rounded px-2 py-1 text-xs text-white" value={phaseInputs.date} onChange={e => setPhaseInputs({...phaseInputs, date: e.target.value})} />
                      <div className="flex gap-2 mt-1">
                        <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-3 py-1 rounded text-xs font-semibold" onClick={() => handleAddPhase(proj.project_id)}>Add Phase</button>
                        <button className="bg-gray-700 hover:bg-gray-800 text-white px-3 py-1 rounded text-xs font-semibold" onClick={() => { setAddingPhaseTo(null); setPhaseInputs({ name: '', status: 'Planning', date: '' }); }}>Cancel</button>
                      </div>
                    </div>
                  ) : (
                    <button className="mt-2 bg-indigo-700 hover:bg-indigo-800 text-white px-3 py-1 rounded text-xs font-semibold" onClick={() => setAddingPhaseTo(proj.project_id)}>+ Add Phase</button>
                  )}
                </div>
              </div>
            ))
          )}
        </div>
        {/* Add Project Modal */}
        {showAddModal && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60">
            <div className="bg-[#23272f] rounded-xl p-8 shadow-2xl border border-gray-700 w-full max-w-md">
              <h2 className="text-xl font-bold mb-4 text-indigo-400 flex items-center gap-2"><FaPlus /> Add New Project</h2>
              <input className="w-full mb-3 px-3 py-2 rounded bg-[#181b20] text-white border border-gray-700" placeholder="Project Name" value={newProject.project_name} onChange={e => setNewProject({...newProject, project_name: e.target.value})} />
              <input className="w-full mb-3 px-3 py-2 rounded bg-[#181b20] text-white border border-gray-700" placeholder="Category" value={newProject.category} onChange={e => setNewProject({...newProject, category: e.target.value})} />
              <input className="w-full mb-3 px-3 py-2 rounded bg-[#181b20] text-white border border-gray-700" placeholder="Chairperson" value={newProject.chairperson} onChange={e => setNewProject({...newProject, chairperson: e.target.value})} />
              <div className="flex gap-3 mt-4">
                <button className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded font-semibold" onClick={handleAddProject}>Add Project</button>
                <button className="bg-gray-700 hover:bg-gray-800 text-white px-4 py-2 rounded font-semibold" onClick={() => setShowAddModal(false)}>Cancel</button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
}
